import { makeStyle } from '../../utils';

const styles = {};

styles['container'] = makeStyle({
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
});

styles['content'] = makeStyle({
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
});

styles['children'] = makeStyle({
    flex: 1,
});

export default styles;